/* __next_internal_client_entry_do_not_use__ RoundingStrategy,Money auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatMoney as newFormatMoney } from "@faire/web--source/common/money";
import * as React from "react";
/**
 * @deprecated Use RoundingStrategy from web-common instead
 * Rounding strategy to use when intending to display whole numbers
 * of dollars only.
 *
 * If you only want to omit the cents when they're zero, use the
 * `omitCentsIfZero` attribute instead.
 */ export var RoundingStrategy;
(function(RoundingStrategy) {
    /**
     * Amounts are not rounded.
     * This is the default behaviour.
     */ RoundingStrategy[RoundingStrategy["NONE"] = 0] = "NONE";
    /**
     * Rounds to the nearest dollar.
     */ RoundingStrategy[RoundingStrategy["ROUND"] = 1] = "ROUND";
    /**
     * Drops the cents from the amount, rounding down (flooring) to
     * the nearest dollar.
     */ RoundingStrategy[RoundingStrategy["DROP_CENTS"] = 2] = "DROP_CENTS";
    /**
     * Drops the cents from the amount, rounding up to the nearest
     * whole dollar.
     */ RoundingStrategy[RoundingStrategy["DROP_CENTS_ROUND_UP"] = 3] = "DROP_CENTS_ROUND_UP";
})(RoundingStrategy || (RoundingStrategy = {}));
export var Money = function(props) {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: newFormatMoney(props)
    });
};
